/**
 * A reading held because the company has no pages left (or too few for this capture), as opposed to one
 * that was interrupted. The API refuses the engine's `process` with a 402 problem titled `credits_exhausted`
 * (EngineCreditGate.NoCreditsCode) and keeps the capture itself, to be read as soon as more pages arrive
 * (WaitingBrowserReads). So the capture is waiting, not lost: the review screen says "Waiting for pages"
 * for it (`StagedCapture.waitingForPages`) instead of offering it back as an unfinished import.
 */
export class PagesHeldError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PagesHeldError';
  }
}

/** The problem title of the credit hold, on the refusal and on a batch's `waitingFor`. */
export const PAGES_HELD_CODE = 'credits_exhausted';

/** Whether an engine refusal is the credit hold: a 402 carrying its code. */
export function isPagesHeld(status: number, body: { title?: unknown } | null | undefined): boolean {
  return status === 402 && body?.title === PAGES_HELD_CODE;
}
